module.exports = __webpack_public_path__ + "img/dc_03.7156c0ed.png";